/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EntityFilterBlock } from './EntityFilterBlock';

/**
 * Personal-tier write. `tier` discriminates between
 * namespace-default writes (set `namespace_id`, leave `scope_key` unset)
 * and page-override writes (set `scope_key`, `namespace_id` optional). A
 * None `block` clears the row at that tier (equivalent to reset).
 */
export type UpdateMyEntityFiltersPayload = {
    tier: UpdateMyEntityFiltersPayload.tier;
    namespaceId?: (string | null);
    scopeKey?: (string | null);
    block?: (EntityFilterBlock | null);
};

export namespace UpdateMyEntityFiltersPayload {

    export enum tier {
        NAMESPACE = 'namespace',
        PAGE = 'page',
    }


}

